import * as types from './actionTypes';
import {ajaxCallError} from './ajaxStatusActions';
import {Api} from '../api/Api';
import {beginAjaxCall, sinReducerSuccess} from './ajaxStatusActions';


export function mensajeSuccess(mensaje) {
  return {type: types.SAVE_CORREO_SUCCESS, mensaje};
}

export function mensaje(mensaje, token) {
    
  return dispatch => {
	dispatch(beginAjaxCall());  
    return Api().CorreoApi.mensaje(mensaje, token).then(mensaje => {   
    dispatch(mensajeSuccess(mensaje));
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}